import {all, call, fork, put, takeEvery} from 'redux-saga/effects'
import {
  QuizzesActionTypes, fetchItemSuccess, fetchItemError, deleteError, deleteSuccess, fetchError, fetchSuccess, createError, createSuccess,
  updateSuccess, updateError
} from '@actions/quiz'
import quizApi from '@api/quiz'
import {ReduxAction} from "@actions/index";
import {RequestData} from '@models/axios';



function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(quizApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err))
  }
}

function* handleFetchItem({payload}: ReduxAction) {
  try {
    const {data} = yield call(quizApi.getItem, payload);
    yield put(fetchItemSuccess(data))
  } catch (err) {
    yield put(fetchError(err))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(quizApi.delete, payload);
    yield put(deleteSuccess(payload));
  } catch (err) {
    yield put(deleteError(err))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(quizApi.create, payload);
    yield updateContentListItems(data.id, payload.payload);
    yield put(createSuccess(data));
    payload.onSuccessCallback && payload.onSuccessCallback(data);
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(quizApi.update, payload);
    yield updateContentListItems(data.id, payload.payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(updateSuccess(data))
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


/**
 * This function handles add and delete content Table items of video with type: video_content_list
 * @param params
 * @param payload
 */
function* updateContentListItems(quiz_id, {videos}) {
  try {
    const {new_videos, selectedItems, deleted_videos} = videos;
    const params = {id : quiz_id};
    if (new_videos.length > 0) {
      yield call(quizApi.addContentListItems, {
        params,
        payload: {
          video_contents: selectedItems.map( item => ({
            "video_content_id": item.id,
            "title": item.title,
            "poster": item.poster_image.path,
            "url": `https://filmnet.ir/contents/${item.short_id}/${item.slug}`
          }))
        }
      });
    }
    
    if (deleted_videos.length > 0) {
      yield call(quizApi.deleteContentListItems, {
        params,
        payload: {
          ids: deleted_videos
        }
      });
    }
  } catch (e) {
    console.log(e)
  }
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* quizzesSaga() {
  yield all([
    yield takeEvery(QuizzesActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(QuizzesActionTypes.FETCH_ITEM_REQUEST, handleFetchItem),
    yield takeEvery(QuizzesActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(QuizzesActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(QuizzesActionTypes.UPDATE_REQUEST, handleUpdate),
  ])
}

export default quizzesSaga
